function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBuildingRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 25c1.379 0 2.5 1.121 2.5 2.5V30h-5v-2.5c0-1.379 1.121-2.5 2.5-2.5z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10h2V7h-2v3zm0 5h2v-3h-2v3zm0 5h2v-3h-2v3zm-5-10h2V7h-2v3zm0 5h2v-3h-2v3zm0 5h2v-3h-2v3zm-5-10h2V7h-2v3zm0 5h2v-3h-2v3zm0 5h2v-3h-2v3zM7 2c-1.1 0-2 .9-2 2v24c0 1.1.9 2 2 2h4.5v-2.5a4.5 4.5 0 019 0V30H25c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H7z",
    fill: props.color
  }));
}

export default SvgIconBuildingRexFilled;